var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLoopIcon = function SvgLoopIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52003 17.1482C7.94648 18.5511 9.84584 19.2903 11.8683 19.2297C13.8617 19.1699 15.7385 18.345 17.153 16.9069L16.2675 16.036C15.0973 17.2367 13.5069 17.9366 11.8311 17.9883C10.1505 18.0387 8.57359 17.4259 7.38893 16.2608L5.46959 14.3899L8.93003 14.3628L8.9203 13.1209L3.33145 13.1646L3.37802 18.7559L4.61991 18.7456L4.59095 15.2677L6.52003 17.1482Z",
    fill: "#605DF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9755 2.81087L16.0045 6.28871L14.0754 4.40827C12.649 3.00534 10.7496 2.26616 8.7272 2.32674C6.73132 2.38754 4.83686 3.22024 3.44252 4.64959L4.32797 5.52041C5.49818 4.31977 7.08853 3.6199 8.76432 3.5681C10.445 3.51774 12.0219 4.13056 13.2065 5.29561L15.1258 7.16654L11.6654 7.19365L11.6751 8.43555L17.264 8.3918L17.2174 2.80053L15.9755 2.81087Z",
    fill: "#605DF9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoopIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loop-icon.b1e39ef0.svg";
export { ForwardRef as ReactComponent };